export default __webpack_public_path__ + "static/media/details-hand-logo.2da556c1.png";